import Vue from "vue";

import DmdLoadingOverlay from "../app/shared/components/old/LoadingOverlay.vue";

Vue.component("DmdLoadingOverlay", DmdLoadingOverlay);
